// removed by extract-text-webpack-plugin
module.exports = {"col-login":"_3wCt6VLREEh-f555wbu43W","login_form":"_3fOzGIxTWVM3IhtneCainT","input":"_262amUxUIzxk3ljjGSMVwZ","forgot":"_32NZxKQ0VbitRRQcNzo-3C","button":"_2JxKKAVCte98Sxe-goKlyq","footer":"VXTj6XMlxcPeiaCgZTeUI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Settings/Login/login.css
// module id = 252
// module chunks = 0